import { useBaseMutation } from "../baseMutation";
import { RestError } from "@maven-rest/common/HttpRequest";
import { CreateEmailVerificationCodeRequest, CreateUserVerificationCodeResponse } from "@maven-rest/sso/UserVerificationCode.dto";
import { UserVerificationCodeUrl } from "@maven-rest/sso/UserVerificationCode.url";

export function useCreateEmailVerificationCodeMutation(req: {
  onSuccess: (data: CreateUserVerificationCodeResponse, variable: CreateEmailVerificationCodeRequest, context: unknown) => void;
  onError: (error: RestError<CreateUserVerificationCodeResponse>, variable: CreateEmailVerificationCodeRequest, context: unknown) => void;
}) {
  return useBaseMutation({
    fnOption: {
      host: process.env.REACT_APP_SSO_BE_URL,
      url: UserVerificationCodeUrl.createEmailVerificationCode,
    },
    onSuccess: req.onSuccess,
    onError: req.onError,
  });
}
